import LGAPI from './_lg.js';
import httpClient from '@/apis/base/httpclient';
import commonFn from '@/commons/commonFunction';

class LgLedgerOriginalAPI extends LGAPI {
  constructor() {
    super();
  }
  controllerName = 'LgOriginalLedgers';

  /**
   * Lấy dữ liệu chứng từ theo 1 nhóm các reftype
   * @param {*} refTypes
   * @param {*} masterColumn
   * @param {*} detailColumn
   * @param {*} filter
   * @param {*} sort
   * @returns
   * NCPHUOC 14/07/2022
   * Modified by NVTUAN1 09.08.2022: Bổ sung thêm tham số sort để sắp xếp
   */
  async getVoucherByRefTypeGroup(refType, isRefType, column, filter, sort) {
    const param = {
      refType: refType,
      isRefType: isRefType,
      column: column,
      filter: filter,
      sort: sort,
    };

    commonFn.nomalizeLoadParameter(param);

    let request = {
      url: this.getAPIUrl() + '/VoucherByRefTypeGroup',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu cho chọn chứng từ ghi sổ
   * HQMINH 08.09.2022
   */
  async getDataGLPostedVoucherOriginalVoucher(payload) {
    const param = {
      refId: payload.refId,
      refType: payload.refType,
      fromDate: payload.fromDate,
      toDate: payload.toDate,
      setup_type: payload.setup_type,
    };
    commonFn.nomalizeLoadParameter(param);

    let request = {
      url: this.getAPIUrl() + '/DataGLPostedVoucherOriginalVoucher',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu chứng từ theo loại chứng từ
   * lttuan1 - 9.7.2022
   */
  async getVoucherByType(param) {
    // Chuẩn hóa param
    //commonFn.nomalizeLoadParameter(param);

    let request = {
      url: this.getAPIUrl() + '/VoucherByType',
      data: param,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Load combobox header
   * lttuan1 - 02.05.2024
   */
  getHeaderComboboxList(payload) {
    let request = {
      url: this.getAPIUrl() + '/HeaderComboboxFilter',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new LgLedgerOriginalAPI();
